var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircleUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.502,
    height: 18.502,
    viewBox: "0 0 18.502 18.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M19.961,13.065l-.783-.8a.168.168,0,0,0-.125-.053h0a.161.161,0,0,0-.125.053L13.5,17.726l-1.975-1.975a.172.172,0,0,0-.249,0l-.792.792a.177.177,0,0,0,0,.254l2.491,2.491a.788.788,0,0,0,.52.254.825.825,0,0,0,.516-.245h0l5.946-5.977A.19.19,0,0,0,19.961,13.065Z",
    transform: "translate(-2.594 -3.245)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M12.626,4.62A8,8,0,1,1,6.964,6.964,7.953,7.953,0,0,1,12.626,4.62m0-1.245a9.251,9.251,0,1,0,9.251,9.251,9.249,9.249,0,0,0-9.251-9.251Z",
    fill: "#a2a2a2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleUnchecked);
export default __webpack_public_path__ + "static/media/checkmark-circle-unchecked.a67fe169d99f362e90bc1a2288e387f9.svg";
export { ForwardRef as ReactComponent };